import Button from "@mui/material/Button";
import { ReactNode } from "react";
import { hapticTap } from "../helpers/haptics";
import { menuColors } from "../theme/menuTheme";

export const optionButtonSx = (selected: boolean) => ({
  minWidth: 44,
  minHeight: 44,
  px: 1.25,
  borderRadius: "10px",
  border: "1px solid",
  borderColor: selected ? menuColors.accent : menuColors.border,
  backgroundColor: selected ? menuColors.accent : menuColors.surfaceRaised,
  color: selected ? "#04342C" : menuColors.text,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: 1.2,
  textTransform: "none" as const,
  boxShadow: "none",
  transition: "background-color 160ms ease, border-color 160ms ease, color 160ms ease",
  "&:hover": {
    borderColor: selected ? menuColors.accent : "#64748b",
    backgroundColor: selected ? menuColors.accent : "rgba(226, 232, 240, 0.06)",
    color: selected ? "#04342C" : menuColors.text
  },
  "&.Mui-disabled": {
    borderColor: menuColors.border,
    backgroundColor: menuColors.surfaceRaised,
    color: menuColors.textMuted,
    opacity: 0.45
  }
});

const OptionButton = ({
  selected,
  onClick,
  children,
  disabled = false,
  ariaLabel,
  fullWidth = false
}: {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
  ariaLabel?: string;
  fullWidth?: boolean;
}) => (
  <Button
    disabled={disabled}
    aria-pressed={selected}
    aria-label={ariaLabel}
    onClick={() => {
      hapticTap();
      onClick();
    }}
    sx={{
      ...optionButtonSx(selected),
      ...(fullWidth ? { width: "100%", px: 1 } : {})
    }}>
    {children}
  </Button>
);

export default OptionButton;
